<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="flex justify-between">
        <span>订单详情</span>
        <div>
          <el-button type="primary" size="small" @click="_goBack">
            <i class="el-icon-close"></i> 返回
          </el-button>
        </div>
      </div>
      <div class="content">
        <el-row :gutter="20">
          <el-col :span="6">
            <div class="form-item">
              <label class="form-label">工单编码：</label>
              <span class="form-value">{{upShopHouseDetailInfo.orderId}}</span>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="form-item">
              <label class="form-label">申请人:</label>
              <span class="form-value">{{upShopHouseDetailInfo.personName}}</span>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="form-item">
              <label class="form-label">申请时间:</label>
              <span class="form-value">{{upShopHouseDetailInfo.createTime}}</span>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="form-item">
              <label class="form-label">订单状态:</label>
              <span class="form-value">{{upShopHouseDetailInfo.stateName}}</span>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <div class="form-item">
              <label class="form-label">备注:</label>
              <span class="form-value">{{upShopHouseDetailInfo.remark}}</span>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-card>

    <el-card class="box-card" style="margin-top: 20px;">
      <div slot="header" class="flex justify-between">
        <span>商品信息</span>
      </div>
      <el-table
        :data="upShopHouseDetailInfo.inoutOrderProducts"
        border
        style="width: 100%">
        <el-table-column
          prop="index"
          label="序号"
          width="100"
          align="center">
          <template slot-scope="scope">
            {{scope.$index + 1}}
          </template>
        </el-table-column>
        <el-table-column
          prop="prodName"
          label="商品名称"
          align="center">
        </el-table-column>
        <el-table-column
          prop="productId"
          label="商品编号"
          align="center">
        </el-table-column>
        <el-table-column
          prop="specName"
          label="规格"
          align="center">
        </el-table-column>
        <el-table-column
          prop="prodCount"
          label="数量"
          align="center">
        </el-table-column>
        <el-table-column
          prop="price"
          label="价格"
          align="center">
        </el-table-column>
        <el-table-column
          prop="amount"
          label="金额"
          align="center">
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import { queryInoutOrder, queryInoutOrderProduct } from '@/api/goods/upShopHouseDetailApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'UpShopHouseDetail',
  data() {
    return {
      upShopHouseDetailInfo: {
        orderId: '',
        stateName: '',
        personName: '',
        createTime: '',
        remark: '',
        inoutOrderProducts: []
      },
      shopId: ''
    }
  },
  created() {
    this.shopId = getShopId()
    this._initData()
  },
  methods: {
    _initData() {
      const orderId = this.$route.query.orderId
      if (!orderId) {
        this.$message.error('非法操作')
        this.$router.go(-1)
        return
      }
      this.upShopHouseDetailInfo.orderId = orderId
      this._listOrder()
      this._listInoutOrderProduct()
    },
    async _listOrder() {
      try {
        const param = {
          page: 1,
          row: 1,
          orderId: this.upShopHouseDetailInfo.orderId
        }
        const res = await queryInoutOrder(param)
        if (res.data && res.data.length > 0) {
          Object.assign(this.upShopHouseDetailInfo, res.data[0])
        }
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    async _listInoutOrderProduct() {
      try {
        const param = {
          page: 1,
          row: 50,
          orderId: this.upShopHouseDetailInfo.orderId,
          shopId: this.shopId
        }
        const res = await queryInoutOrderProduct(param)
        this.upShopHouseDetailInfo.inoutOrderProducts = res.data || []
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    _goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.form-item {
  margin-bottom: 15px;
}
.form-label {
  display: inline-block;
  width: 80px;
  text-align: right;
  margin-right: 10px;
  color: #606266;
}
.form-value {
  color: #303133;
}
.box-card {
  margin-bottom: 20px;
}
.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}
</style>